/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardThreatsByResourceCategoryCount {
    getFixupPrototypeFunction() { return SecurityDashboardThreatsByResourceCategoryCount.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardThreatsByResourceCategoryCount>): SecurityDashboardThreatsByResourceCategoryCount {
        let obj = Object.assign(new SecurityDashboardThreatsByResourceCategoryCount(), model);
        SecurityDashboardThreatsByResourceCategoryCount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardThreatsByResourceCategoryCount>): SecurityDashboardThreatsByResourceCategoryCount {
        if (!model) return null;
        return SecurityDashboardThreatsByResourceCategoryCount.newInstance(<SecurityDashboardThreatsByResourceCategoryCount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardThreatsByResourceCategoryCount) {
        if (!obj) return;

        models.SecurityDashboardThreatsByResourceCategoryCount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardThreatsByResourceCategoryCount): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardThreatsByResourceCategoryCount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.threat_count === undefined) {
            this.threat_count = 0;
        }
        if (this.resource_count === undefined) {
            this.resource_count = 0;
        }
    }

    /**
     * Cloud Account Id
     */
    cloud_account_id: string;

    /**
     * Name of the Resource Category
     */
    resource_category: string;

    /**
     * Threats Total Count by resource category
     */
    threat_count: number;

    /**
     * Total Count by Resource
     */
    resource_count: number;

}
